<div class="row">
  <div class="privacy_policy_content">
    <div class="row">
      <div class="privacy_policy_logo">
        <img src="../../assets/img/new_dasboard_imges/loginbluvbay.png" height="57" width="165"/>
      </div>
    </div>
    <div class="row">
      <div class="policy_heading">
        <h2>Terms and Conditions</h2>
      </div>
    </div>
    <div class="row">
      <div class="privacy_content">
        <ul>
          <ol type="1">
            <li class="terms_heading">Introduction and Acceptance</li>
            <p>Please read these terms of use carefully before using www.aqucloud.com (hereinafter, "us", "we", or
              "aqucloud.com"). By accessing and/or using aqucloud.com (other than to read these terms of use for the
              first time) you are agreeing to comply with these terms of use, which may change from time to time as set
              forth in section 16 below. If you do not agree to be bound by these terms of use, do not access or use
              aqucloud.com.
            </p>
            <p>You agree that these Terms of Use are supported by good and valuable consideration the receipt and
              sufficiency of which you hereby acknowledge. Such consideration includes, without limitation, your use of
              aqucloud.com and the materials and information available on the same.</p>
            <p>In addition to these Terms of Use, aqucloud.com has established a Privacy Policy to explain how user
              information is collected and used by aqucloud.com. A copy of this Privacy Policy can be found here:
              <a href="https://www.aqucloud.com/privacy/">https://www.aqucloud.com/privacy/ </a>and is incorporated by reference into these Terms of Use. By accessing
              or using any of our Websites, you are signifying your acknowledgement and agreement to aqucloud.com's
              Privacy Policy.
            </p>
            <li class="terms_heading">Intellectual Property</li>
            <p>
              aqucloud.com and included content (and any derivative works or enhancements of the same) including, but
              not limited to, all text, illustrations, files, images, software, scripts, graphics, photos, sounds,
              music, videos, information, content, materials, products, services, URLs, technology, documentation, and
              interactive features (collectively, the "Website Content") and all intellectual property rights to the
              same are owned by us, our licensors, or both. Additionally, all trademarks, service marks, trade names and
              trade dress that may appear on our Websites are owned by us, our licensors, or both. You shall not acquire
              any right, title or interest in our Websites or any Website Content. Any rights not expressly granted in
              these Terms of Use are expressly reserved.
            </p>
            <li class="terms_heading">aqucloud.com Access and Use</li>
            <ol type="1">
              <li>When accessing our Websites, including without limitation to the Website Content, you agree to
                comply with all applicable federal, state, and local laws including, without limitation copyright law.
                Except as expressly permitted in these Terms of Use, you may not use, reproduce, distribute, create
                derivative works based upon, publicly display, publicly perform, publish, transmit, or otherwise exploit
                Website Content for any purpose whatsoever without obtaining prior written consent from us or, in the
                case of third-party content, its respective owner. You acknowledge that you do not acquire any ownership
                rights by downloading or printing Website Content.
              </li>
              <li>Furthermore, except as expressly permitted in these Terms of Use, you may not:</li>
              <ol type="1">
                <li>remove, alter, cover, or distort any copyright, trademark, or other proprietary rights notice on
                  Aqucloud.com or Website Content;
                </li>
                <li>circumvent, disable or otherwise interfere with security-related features of our Websites
                  including, without limitation, any features that prevent or restrict use or copying of any content or
                  enforce limitations on the use of our Websites or Website Content;
                </li>
                <li>Use an automatic device (such as a robot or spider) or manual process to copy or "scrape" our
                  Websites or Website Content for any purpose without the express written permission of Aqucloud.com.
                  Notwithstanding the foregoing, aqucloud.com grants public search engine operators permission to use
                  automatic devices (such as robots or spiders) to copy Website Content from our Websites for the sole
                  purpose of creating (and only to the extent necessary to create) a searchable index of Website Content
                  that is available to the public. aqucloud.com reserves the right to revoke this permission (generally
                  or specifically) at any time;
                </li>
                <li>collect or harvest any personally identifiable information from our Websites including, without
                  limitation, user names, passwords, email addresses;
                </li>
                <li>solicit other users to join or become members of any commercial online service or other organization
                  without our prior written approval;
                </li>
                <li>attempt to or interfere with the proper working of our Websites or impair, overburden, or disable
                  the same;
                </li>
                <li>decompile, reverse engineer, or disassemble any portion of any our Websites;</li>
                <li>use network-monitoring software to determine architecture of or extract usage data from any of our
                  Websites;
                </li>
                <li>Encourage conduct that violates any local, state or federal law, either civil or criminal, or
                  impersonate another user, person, or entity (e.g., using another person's Membership (as defined in
                  Section B) without permission, etc.);
                </li>
                <li>violate export laws, including, without limitation, violations of the Export Administration Act and
                  the Export Administration Regulations administered by the Department of Commerce; or
                </li>
                <li>Engage in any conduct that restricts or inhibits any other user from using or enjoying our
                  Websites.
                </li>
              </ol>
              <li>You agree to cooperate fully with Aqucloud.com to investigate any suspected or actual activity that
                is in breach of these Terms of Use.
              </li>
            </ol>
            <li class="terms_heading">User Registration</li>
            <ol type="1">
              <li>In order to access or use some features of Aqucloud.com, you will have to become a registered user.
                If you are under the age of eighteen, then you are not permitted to register as a user or otherwise
                submit personal information to Aqucloud.com.
              </li>
              <li>If you become a registered user, you will provide true, accurate and complete registration
                information and, if such information changes, you will promptly update the relevant registration
                information. During registration, you will create a user name and password (a "Membership"), which may
                permit you access to certain areas of our Websites not available to non-registered users. You are
                responsible for safeguarding and maintaining the confidentiality of your Membership. You are solely
                responsible for the activity that occurs under your Membership, whether or not you have authorized the
                activity. You agree to notify us immediately at <a href="https://www.aqucloud.com/contact/">https://www.aqucloud.com/contact/</a> of any breach of
                security or unauthorized use of your Membership.
              </li>
            </ol>
            <li class="terms_heading">User Content</li>
            <ol type="1">
              <li>We may now or in the future permit users to post, upload, transmit through, or otherwise make
                available on our Websites (collectively, "submit") messages, templates, text, illustrations, files,
                images, graphics, photos, comments, sounds, music, videos, information, content, and/or other
                materials ("User Content"). Subject to the rights and license you grant herein, you retain all right,
                title and interest in your User Content. We do not guarantee any confidentiality with respect to User
                Content even if it is not published on our Websites. It is solely your responsibility to monitor and
                protect any intellectual property rights that you may have in your User Content, and we do not accept
                any responsibility for the same.
              </li>
              <li>You shall not submit any User Content protected by copyright, trademark, patent, trade secret, moral
                right, or other intellectual property or proprietary right without the express permission of the owner
                of the respective right. You are solely liable for any damage resulting from your failure to obtain
                such permission or from any other harm resulting from User Content that you submit.
              </li>
              <li>You represent, warrant, and covenant that you will not submit any User Content that:</li>
              <ol type="1">
                <li>violates or infringes in any way upon the rights of others, including, but not limited to, any
                  copyright, trademark, patent, trade secret, moral right, or other intellectual property or
                  proprietary right of any person or entity;
                </li>
                <li>impersonates another or is unlawful, threatening, abusive, libelous, defamatory, invasive of
                  privacy or publicity rights, vulgar, obscene, profane, pornographic, or otherwise objectionable;
                </li>
                <li>encourages conduct that would constitute a criminal offense, give rise to civil liability or
                  otherwise violate any law;
                </li>
                <li>is an advertisement for goods or services or a solicitation of funds;</li>
                <li>includes personal information such as messages which identify phone numbers, social security
                  numbers, account numbers, addresses, or employer references;
                </li>
                <li>Contains a formula, instruction, or advice that could cause harm or injury; or is a chain letter
                  of any kind.
                </li>
              </ol>
              <p>Moreover, any conduct by a user that in our sole discretion restricts or inhibits any other user from
                using or enjoying our Websites will not be permitted.
              </p>
              <li>By submitting User Content to us, simultaneously with such posting you automatically grant, or
                warrant that the owner has expressly granted, to us a worldwide, royalty-free, perpetual, irrevocable,
                non-exclusive, fully sub licensable, and transferable right and license to use, reproduce, distribute,
                create derivative works based upon (including, without limitation, translations), publicly display,
                publicly perform, transmit, and publish the User Content (in whole or in part) as we, in our sole
                discretion, deem appropriate including, without limitation, (1) in connection with our business; and
                (2) in connection with the businesses of our successors, parents, subsidiaries, and their related
                companies. We may exercise this grant in any format, media or technology now known or later developed
                for the full term of any copyright that may exist in such User Content. Furthermore, you also grant
                other users permission to access your User Content and to use, reproduce, distribute, create
                derivative works based upon, publicly display, publicly perform, transmit, and publish your User
                Content for personal, non-commercial use as permitted by the functionality of any of our Websites and
                these Terms of Use.
              </li>
              <li>By submitting User Content, you also grant us the right, but not the obligation to use your
                biographical information including, without limitation, your name and geographical location in
                connection with broadcast, print, online, or other use or publication of your User Content.
                Notwithstanding the foregoing, you waive any and all claims you may now or later have in any
                jurisdiction to so-called "moral rights" or rights of "droit moral" with respect to the User Content.
              </li>
              <li>We reserve the right to display advertisements in connection with your User Content and to use your
                User Content for advertising and promotional purposes. You acknowledge and agree that your User
                Content may be included on the websites and advertising networks of our distribution partners and
                third-party service providers (including their downstream users).
              </li>
              <li>We have the right, but not the obligation, to monitor User Content. We have the right in our sole
                discretion and for any reason whatsoever to edit, refuse to post, remove, or disable access to any
                User Content.
              </li>
            </ol>
            <li class="terms_heading">Website Content & Third Party Links</li>
            <ol type="1">
              <li>We provide our Websites and Website Content, for the commercial, entertainment and promotional
                purposes of providing web-based services for the web design and web development of others. You may not
                rely on any information and opinions expressed on any of our Websites for any other purpose. In all
                instances, it is your responsibility to evaluate the accuracy, timeliness, completeness, or usefulness
                of Website Content. Under no circumstances will we be liable for any loss or damage caused by your
                reliance on any Website Content.
              </li>
              <li>In many instances, Website Content will include content posted by a third-party or will represent the
                opinions and judgments of a third-party. We do not endorse, warrant and are not responsible for the
                accuracy, timeliness, completeness, or reliability of any opinion, advice, or statement made on our
                Websites by anyone other than authorized employees or spokespersons while acting in their official
                capacities.
              </li>
              <li>If there is a dispute between persons accessing our Websites or between persons accessing our Websites
                and any third party, you understand and agree that we are under no obligation to become involved. If
                there
                is such a dispute, you hereby release Aqucloud.com and its officers, directors, employees, parents,
                partners, successors, agents, affiliates, subsidiaries, and their related companies from claims,
                demands,
                and damages of every kind or nature arising out of, relating to, or in any way connected with such
                dispute.
              </li>
              <li>Our Websites may contain links to other websites maintained by third parties. We do not operate or
                control, in any respect, or necessarily endorse the content found on these third-party websites. You
                assume sole responsibility for your use of third-party links. We are not responsible for any content
                posted on third-party websites or liable to you for any loss or damage of any sort incurred as a result
                of your dealings with any third-party or their website.
              </li>
            </ol>
            <li class="terms_heading">Indemnification</li>
            <p>You agree to indemnify and hold harmless Aqucloud.com and its officers, directors, employees, parents,
              partners, successors, agents, distribution partners, affiliates, subsidiaries, and their related
              companies from and against any and all claims, liabilities, losses, damages, obligations, costs and
              expenses (including reasonable attorneys' fees and costs) arising out of, related to, or that may arise
              in connection with: (i) your access to or use of any of our Websites; (ii) User Content provided by you
              or through use of your Membership; (iii) any actual or alleged violation or breach by you of these Terms
              of Use; (iv) any actual or alleged breach of any representation, warranty, or covenant that you have
              made to us; or (v) your acts or omissions. You agree to cooperate fully with us in the defense of any
              claim that is the subject of your obligations hereunder.
            </p>
            <li class="terms_heading">Disclaimers</li>
            <p>YOU EXPRESSLY AGREE THAT USE OF OUR WEBSITES IS AT YOUR SOLE RISK. OUR WEBSITES AND WEBSITE CONTENT ARE
              PROVIDED ON AN "AS IS" AND "AS AVAILABLE" BASIS WITHOUT WARRANTY OF ANY KIND, EITHER EXPRESS OR IMPLIED.
              WITHOUT LIMITING THE FOREGOING AND TO THE FULLEST EXTENT PERMITTED BY LAW, AQUCLOUD.COM AND ITS
              OFFICERS, DIRECTORS, EMPLOYEES, PARENTS, PARTNERS, SUCCESSORS, AGENTS, DISTRIBUTION PARTNERS,
              AFFILIATES, SUBSIDIARIES, AND THEIR RELATED COMPANIES DISCLAIM ANY AND ALL WARRANTIES INCLUDING ANY: (1)
              WARRANTIES THAT THE WEBSITES WILL MEET YOUR REQUIREMENTS; (2) WARRANTIES CONCERNING THE AVAILABILITY,
              ACCURACY, SECURITY, USEFULNESS, TIMELINESS, OR INFORMATIONAL CONTENT OF THE AQUCLOUD.COM; (3) WARRANTIES
              OF TITLE, NON-INFRINGEMENT, MERCHANTABILITY, OR FITNESS FOR A PARTICULAR PURPOSE; (4) WARRANTIES FOR
              SERVICES OR GOODS RECEIVED THROUGH OR ADVERTISED ON OUR WEBSITES OR ACCESSED THROUGH ANY OF OUR
              WEBSITES; (5) WARRANTIES CONCERNING THE ACCURACY OR RELIABILITY OF THE RESULTS THAT MAY BE OBTAINED FROM
              THE USE OF THE WEBSITES; (6) WARRANTIES THAT YOUR USE OF THE WEBSITES WILL BE SECURE OR UNINTERRUPTED;
              AND (7) WARRANTIES THAT ERRORS IN THE SOFTWARE WILL BE CORRECTED.
            </p>
            <li class="terms_heading">Limitation on Liability</li>
            <ol type="1">
              <li>UNDER NO CIRCUMSTANCES SHALL AQUCLOUD.COM OR ITS OFFICERS, DIRECTORS, EMPLOYEES, PARENTS, PARTNERS,
                SUCCESSORS, AGENTS, DISTRIBUTION PARTNERS, AFFILIATES, SUBSIDIARIES, OR THEIR RELATED COMPANIES BE
                LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR EXEMPLARY DAMAGES (EVEN IF AQUCLOUD.COM HAS
                BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGES), ARISING OUT OF, RELATING TO, OR IN ANY WAY CONNECTED
                WITH OUR WEBSITES OR THESE TERMS OF USE. YOUR SOLE REMEDY FOR DISSATISFACTION WITH OUR WEBSITES
                INCLUDING, WITHOUT LIMITATION, THE WEBSITE CONTENT IS TO STOP USING OUR WEBSITES. SUCH LIMITATION
                SHALL ALSO APPLY WITH RESPECT TO DAMAGES INCURRED BY REASON OF SERVICES OR PRODUCTS RECEIVED THROUGH
                OR ADVERTISED IN CONNECTION WITH ANY OF OUR WEBSITES OR ANY LINKS ON OUR WEBSITES, AS WELL AS BY
                REASON OF ANY INFORMATION OR ADVICE RECEIVED THROUGH OR ADVERTISED IN CONNECTION WITH ANY OF OUR
                WEBSITES OR ANY LINKS ON OUR WEBSITES. SUCH LIMITATION SHALL ALSO APPLY WITH RESPECT TO DAMAGES
                INCURRED BY REASON OF ANY CONTENT POSTED BY A THIRD-PARTY OR CONDUCT OF A THIRD-PARTY ON OUR WEBSITES.
              </li>
              <li>NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, IN NO EVENT SHALL THE CUMULATIVE
                LIABILITY
                OF AQUCLOUD.COM AND ITS OFFICERS, DIRECTORS, EMPLOYEES, PARENTS, PARTNERS, SUCCESSORS, AGENTS,
                DISTRIBUTION PARTNERS, AFFILIATES, SUBSIDIARIES, AND THEIR RELATED COMPANIES EXCEED THE GREATER OF THE
                TOTAL PAYMENTS RECEIVED FROM YOU BY AQUCLOUD.COM DURING THE PRECEDING TWELVE (12) MONTH PERIOD OR
                $100.
                FURTHERMORE, YOU AGREE THAT ANY CAUSE OF ACTION ARISING OUT OF, RELATING TO, OR IN ANY WAY CONNECTED
                WITH ANY OF OUR WEBSITES OR THESE TERMS OF USE MUST COMMENCE WITHIN ONE (1) YEAR AFTER THE CAUSE OF
                ACTION ACCRUES; OTHERWISE, SUCH CAUSE OF ACTION SHALL BE PERMANENTLY BARRED.
              </li>
              <li>IN SOME JURISDICTIONS LIMITATIONS OF LIABILITY ARE NOT PERMITTED. IN SUCH JURISDICTIONS, SOME OF THE
                FOREGOING LIMITATIONS MAY NOT APPLY TO YOU. THESE LIMITATIONS SHALL APPLY TO THE FULLEST EXTENT
                PERMITTED BY LAW.
              </li>
            </ol>
            <li class="terms_heading">Termination</li>
            <ol type="1">
              <li>We reserve the right in our sole discretion and at any time to terminate or suspend your Membership
                and/or block your access to our Websites for any reason including, without limitation if you have
                failed to comply with the letter and spirit of these Terms of Use. You agree that Aqucloud.com shall
                not be liable to you or any third party for any termination or suspension of your Membership or for
                blocking your access to our Websites.
              </li>
              <li>If you become a registered user, you may terminate your Membership at any time by going to
                Membership page and selecting the appropriate option.
              </li>
              <li>Any suspension or termination shall not affect your obligations to us under these Terms of Use. The
                provisions of these Terms of Use which by their nature should survive the suspension or termination of
                your Membership or these Terms of Use shall survive including, but not limited to the rights and
                licenses that you have granted hereunder, indemnities, releases, disclaimers, limitations on
                liability, provisions related to choice of law, dispute resolution, no class action, no trial by jury
                and all of the miscellaneous provisions in Section Acts.
              </li>
            </ol>
            <li class="terms_heading">Copyright Policy</li>
            <ol type="1">
              <li>Aqucloud.com respects the intellectual property rights of others and expects its users to do the
                same. In appropriate circumstances and at its sole discretion, Aqucloud.com may terminate and/or
                disable the Membership of users who it suspects to be infringers of the copyrights (or other
                intellectual property rights) of others. Additionally, in appropriate circumstances and in its sole
                discretion, Aqucloud.com may remove or disable access to material on any of its websites or hosted on
                its systems that may be infringing or the subject of infringing activity.
              </li>
              <li>If you are a copyright owner (or authorized to act on behalf of the copyright owner) and believe
                that your work's copyright has been infringed, please report your notice of infringement to us by
                providing our Designated Agent with a written notification of claimed infringement that includes
                substantially the following:
              </li>
              <ol type="1">
                <li>A physical or electronic signature of a person authorized to act on behalf of the owner of an
                  exclusive right that is allegedly infringed.
                </li>
                <li>Identification of the copyrighted work claimed to have been infringed, or, if multiple copyrighted
                  works at a single online site are covered by a single notification, a representative list of such
                  works at that site.
                </li>
                <li>Identification of the material that is claimed to be infringing or to be the subject of infringing
                  activity and that is to be removed or access to which is to be disabled, and information reasonably
                  sufficient to permit us to locate the material.
                </li>
                <li>Information reasonably sufficient to permit us to contact you, such as an address, telephone
                  number, and, if available, an electronic mail address at which you may be contacted.
                </li>
                <li>A statement that you have a good faith belief that use of the material in the manner complained of
                  is not authorized by the copyright owner, its agent, or the law.
                </li>
                <li>A statement that the information in the notification is accurate, and under penalty of perjury,
                  that you are authorized to act on behalf of the owner of an exclusive right that is allegedly
                  infringed.
                </li>
              </ol>
              <p>We will investigate notices of copyright infringement and take appropriate actions. Inquiries that
                do not follow this procedure may not receive a response.
              </p>
            </ol>
            <li class="terms_heading">Amendment; Additional Terms</li>
            <ol type="1">
              <li>We reserve the right in our sole discretion and at any time and for any reason, to modify or
                discontinue any aspect or feature of our Websites or to modify these Terms of Use. In addition, we
                reserve the right to provide you with operating rules or additional terms that may govern your use of
                our Websites generally, unique parts of our Websites, or both ("Additional Terms"). Any Additional
                Terms
                that we may provide to you will be incorporated by reference into these Terms of Use. To the extent
                any
                Additional Terms conflict with these Terms of Use, the Additional Terms will control.
              </li>
              <li>Modifications to these Terms of Use or Additional Terms will be effective immediately upon notice,
                either by posting on our Websites or by notification by email or conventional mail. It is your
                responsibility to review the Terms of Use and our Websites from time to time for any changes or
                Additional Terms. Your access and use of any our Websites following any modification of these Terms of
                Use or the provision of Additional Terms will signify your assent to and acceptance of the same. If
                you
                object to any subsequent revision to the Terms of Use or to any Additional Terms, you may terminate
                your
                Membership as provided in Section B herein or, if you do not have an Membership, your only recourse is
                to immediately discontinue use of our Websites.
              </li>
            </ol>
            <li class="terms_heading">Miscellaneous</li>
            <ol type="1">
              <li>No waiver by either party of any breach or default hereunder shall be deemed to be a waiver of any
                preceding or subsequent breach or default. The section headings used herein are for convenience only
                and shall not be given any legal import. If any provision of these Terms of Use is held to be invalid
                or unenforceable, the invalidity of such provision shall not affect the validity of the remaining
                provisions of the Terms of Use, which shall remain in full force and effect.
              </li>
              <li>These Terms of Use (including the Privacy Policy and any Additional Terms incorporated by reference)
                constitute the entire agreement of the parties with respect to the subject matter hereof, and
                supersede
                all previous written or oral agreements between us with respect to such subject matter.
              </li>
              <li>You may not assign these Terms of Use or assign any rights or delegate any obligations hereunder, in
                whole or in part, without our prior written consent. Any such purported assignment or delegation by
                you
                without the appropriate prior written consent will be null and void and of no force and effect.
                Aqucloud.com may assign these Terms of Use or any rights hereunder without your consent and without
                notice.
              </li>
            </ol>
            <li class="terms_heading">Notices</li>
            <P>All notices, requests, and communications hereunder shall be in writing, and any such notice, request
              or other communication shall be deemed to have been given or made when delivered by hand, transmitted by
              fax and confirmed or, in the case of delivery by mail, when deposited in the mail, certified mail,
              return receipt requested, postage prepaid, to: Aqucloud.com, H.No. 8-2-248/A/B, Ground Floor, Road No.3
              Land Mark: Chutney's, Banjara Hills, Hyderabad, Telangana, 500034.
            </P>
          </ol>
        </ul>
        <p class="queries">For any Queries and clarifications, Please mail <a>ravisingh.kshatri@iprotechs.com</a></p>
      </div>
    </div>
  </div>
</div>

